@let isCustomDeleted = isDisabled() && getCustomValueState('id');

<mat-expansion-panel
  class="cta-expansion-panel"
  [class.analytics-mode-panel]="analyticsMode()"
  [class.view-mode]="isViewMode()"
  [disabled]="isCustomDeleted || analyticsMode()"
  [expanded]="(isPanelExpanded() && !isCustomDeleted) || analyticsMode()"
  [hideToggle]="analyticsMode()"
  (expandedChange)="onPanelExpandedChange($event)"
>
  <mat-expansion-panel-header class="deliverable-flow-expansion-panel-header">
    <mat-panel-title>
      <div class="flex flex-1 justify-between items-center">
        <div class="flex flex-grow flex-col mr-8">
          <div class="flex gap-2">
            <app-editable-title
              fontClasses="font-bold"
              [class.text-sm]="!analyticsMode()"
              [icon]="form().invalid ? 'icons/circle-x.svg' : 'icons/circle-check.svg'"
              [iconColor]="form().invalid ? 'var(--shikenso-error-bright)' : 'var(--shikenso-pink-base)'"
              [iconSize]="16"
              [subtitle]="config.subtitleTranslationKey | translate"
              [control]="name"
              [isViewMode]="isViewMode()"
              [disabled]="isCustomDeleted"
              [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
              [infoTooltip]="
                'pages.campaignForm.ctaDialog.ctaDetails.deliverables.descriptions.' + config.type | translate
              "
              [creatorBriefingMode]="creatorBriefingMode()"
              [showRequiredBadge]="showRequiredBadge()"
            />

            @if (showSeparator()) {
              <hr class="flex-1 ml-2 pb-0.5 border border-shikenso-purple-base-12 self-center" />
            }
          </div>

          @if (description()) {
            <div class="text-xs">{{ description() }}</div>
          }
        </div>

        @if (!isViewMode()) {
          <div class="flex items-center gap-7">
            <app-deliverable-advanced-button
              [platformFeature]="platformFeature()"
              [deliverableType]="config.type"
              [isOpen]="showAdvancedSettings()"
              (toggled)="onToggleAdvancedSettings()"
            />

            <div class="flex items-center">
              @if (isCustomMode() && !form().value.exclusiveTo) {
                <app-custom-remove-button
                  [checked]="!getCustomValueState('id')"
                  (checkboxStateChanged)="onDeleteCheckboxChange('id', $event)"
                  #deleteParentButton
                />
              } @else {
                <button
                  mat-icon-button
                  class="mat-secondary-transparent-button-color"
                  (click)="onDeleteClick(form().value.exclusiveTo)"
                >
                  <app-icon src="/icons/trash.svg" alt="delete" [size]="16" />
                </button>
              }
            </div>
          </div>
        }
      </div>
    </mat-panel-title>

    @if (isCustomDeleted) {
      <svg
        class="absolute top-1/2 -translate-y-1/2 right-1 opacity-[24%] w-6 h-6 mt-[1px]"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        aria-hidden="true"
        focusable="false"
      >
        <path d="M480-345 240-585l56-56 184 184 184-184 56 56-240 240Z"></path>
      </svg>
    }
  </mat-expansion-panel-header>

  <div class="flex flex-col flex-1 gap-3" [formGroup]="form()">
    <div class="flex items-start gap-2">
      <mat-form-field
        class="w-full min-w-0 flex-1 expandable-textarea-field"
        matTooltipPosition="above"
        [class.custom-value-border]="
          isCustomMode() && !isViewMode() && (form().value.exclusiveTo || getCustomValueState(config.textFieldName))
        "
        [matTooltip]="isViewMode() ? form().controls[config.textFieldName].value : null"
        [matTooltipDisabled]="true"
      >
        <mat-label>{{ config.placeholderTranslationKey | translate }}</mat-label>
        <textarea
          matInput
          cdkTextareaAutosize
          class="!flex !items-center"
          [formControlName]="config.textFieldName"
          cdkAutosizeMinRows="3"
          cdkAutosizeMaxRows="10"
        ></textarea>

        @if (
          isCustomMode() && !isViewMode() && !form().value.exclusiveTo && getCustomValueState(config.textFieldName)
        ) {
          <span matSuffix>
            <button
              mat-icon-button
              type="button"
              class="mat-secondary-transparent-button-color"
              [disabled]="isCustomDeleted"
              (click)="onRevertToGlobalClick(config.textFieldName)"
            >
              <app-icon src="/icons/rotate-360.svg" class="w-4 h-4" />
            </button>
          </span>
        }
        <mat-error [control]="form().get(config.textFieldName)" />
      </mat-form-field>

      @if (form().value.status && isViewMode() && showStatusBadge() && manualDeliverableStatusConfig()?.statusVisible) {
        @let topicKey = form().getRawValue()[config.textFieldName];
        @let isAnalyticsCountVisible =
          form().value.analyticsCurrentCount !== null && form().value.analyticsCurrentCount !== undefined;

        <div class="ml-1 shrink-0 flex items-center h-fill-available">
          <app-analytics-status-badge
            [currentCount]="form().value.analyticsCurrentCount"
            [currentRatio]="form().value.analyticsCurrentRatio"
            [jumpActionDisabled]="disableAnalyticsKeywordJumpAction(topicKey)"
            [loading]="analyticsBadgeLoading()"
            [showJumpAction]="showAnalyticsKeywordJumpAction(topicKey)"
            [showJumpActionLoader]="showAnalyticsKeywordJumpLoader(topicKey)"
            [showPillLoader]="isAnalyticsCountVisible"
            [status]="form().value.status"
            (jumpAction)="onAnalyticsKeywordJump(topicKey)"
          />
        </div>
      }
    </div>
  </div>

  @if (showAdvancedSettings() && !isViewMode()) {
    <div class="pl-3 mt-4">
      <app-deliverable-advanced-settings-section
        [form]="form()"
        [platformFeature]="platformFeature()"
        [deliverableType]="config.type"
        [isCustomMode]="isCustomMode()"
        [creatorId]="creatorId()"
      />
    </div>
  }
</mat-expansion-panel>
